import { useReadContract } from 'wagmi';
import { formatEther } from 'viem';

import { sankoWagerContract } from '@src/lib/consts';

export default function useWagerContractMeta() {
  const { data: minimumDMT } = useReadContract({
    ...sankoWagerContract,
    functionName: 'minimumDMT',
    query: {
      select: (minimumDMT) => formatEther(minimumDMT),
    },
  });

  const { data: maximumDMT } = useReadContract({
    ...sankoWagerContract,
    functionName: 'maximumDMT',
    query: {
      select: (maximumDMT) => formatEther(maximumDMT),
    },
  });

  return { minimumDMT, maximumDMT };
}
